import { Grid, Typography } from '@mui/material';

const PageHeader = ({ title }: any) => {
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <Typography variant="h3" component="h3" gutterBottom>
          {title}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default PageHeader;
